import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const StarIcon = (props: IconProps) => (
  <Icon width="15px" height="14px" viewBox="0 0 15 14" {...props}>
    <path d="m9.81018 4.26229 3.78822.5464c.3179.05204.5828.26019.6888.57242.106.28622.0265.62447-.2119.83262l-2.7551 2.67999.6623 3.79878c.0529.3123-.0795.6245-.3444.8066-.2649.2082-.6093.2082-.9007.0781l-3.3909-1.7953-3.41737 1.7953c-.26491.1301-.63579.1301-.87421-.0781-.26491-.1821-.39737-.4943-.34439-.8066l.63579-3.79878L.591233 6.21373c-.238421-.20815-.317895-.5464-.21193-.83262.105965-.31223.370877-.52038.688777-.57242l3.81473-.5464L6.57825.801721c.13246-.286212.42386-.468347.76825-.468347.31789 0 .6093.182135.74175.468347L9.81018 4.26229Z" />
  </Icon>
);

export default memo(StarIcon);
